import React from 'react';

import { observer } from 'mobx-react';

import { TabTitle } from 'containers/UserDetails/components/PersonalInformation/styles';

import { useStore } from 'utils/hooks/store';

import GroupMembershipList from './GroupMembershipList';

import { GroupsHeader } from './styles';

const UserGroupsCard: React.FunctionComponent = () => {
  const { session, userDetails } = useStore();
  const details = userDetails.details;

  if (!details) {
    return null;
  }

  const isSelf = session.user?.uuid === details.uuid;

  return (
    <>
      <GroupsHeader>
        <TabTitle>Groups</TabTitle>
      </GroupsHeader>
      <GroupMembershipList
        userUuid={details.uuid}
        emptyText={isSelf ? "You're not in any groups yet." : `${details.name} is not in any groups yet.`}
      />
    </>
  );
};

export default observer(UserGroupsCard);
